export const CHART_EXPORT_MODES = Object.freeze({
  INTERACTIVE: 'interactive',
  SNAPSHOT: 'snapshot',
});

export const hasInteractiveChartExportContract = (config) => Boolean(
  config
  && typeof config === 'object'
  && (config.interactiveControls === 'auto' || (
  config.initialChartState
  && typeof config.renderChartControls === 'function'
  && typeof config.renderChart === 'function'
  && (typeof config.buildMetadata === 'function' || config.metadata)
  ))
);

export const getChartExportMode = (config) => {
  if (config === false) return null;
  if (config?.mode) return config.mode;
  return hasInteractiveChartExportContract(config)
    ? CHART_EXPORT_MODES.INTERACTIVE
    : CHART_EXPORT_MODES.SNAPSHOT;
};

export const validateChartExportConfig = (config) => {
  const mode = getChartExportMode(config);
  if (mode === CHART_EXPORT_MODES.INTERACTIVE && !hasInteractiveChartExportContract(config)) {
    return 'Interactive chart exports require initialChartState, renderChartControls, renderChart, and metadata/buildMetadata.';
  }
  if (mode && !Object.values(CHART_EXPORT_MODES).includes(mode)) {
    return `Unknown chart export mode: ${mode}`;
  }
  return null;
};
